/**
 * TRIL-677: build the topic-feed route for the VIEWER.
 *
 * handleTopicClick used to interpolate the topic into the ':username' segment, producing
 * /user/politics/feed. It happened to work because the page reads ?topic and the resolver
 * keys the feed off the authenticated caller -- but it implies a user named "politics" and
 * is one refactor away from breaking.
 *
 * Extracted so the URL shape is testable without mounting the component.
 */
import { PRIVATE_URIS } from '../../constants/privateURIs.constants';
import { resolveNavRoute } from '../../helpers/resolveNavRoute';

export function buildTopicRoute(
  topic: string,
  username: string | null | undefined,
): string | null {
  // resolveNavRoute leaves ':username' in place for a falsy name, which would navigate to
  // the literal template. Redux user can blip falsy during navigation (TRIL-297), so refuse.
  if (!username) return null;
  return `${resolveNavRoute(PRIVATE_URIS.FEED, username)}?topic=${encodeURIComponent(topic)}`;
}
